import React, { useState, useEffect } from 'react';
import ChatWindow from './ChatWindow';
import './ClienteView.css';
import logoImagotipo from '../../assets/img/imagotipo-logo.png';

function ClienteView() {
  const [nombre, setNombre] = useState('');
  const [telefono, setTelefono] = useState('');
  const [clienteId, setClienteId] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const savedId = localStorage.getItem('cliente_id');
    const savedNombre = localStorage.getItem('nombre_cliente');
    const savedTel = localStorage.getItem('telefono_cliente');

    if (savedId && savedNombre && savedTel) {
      setClienteId(savedId);
      setNombre(savedNombre);
      setTelefono(savedTel);
    }
  }, []);

  const handleRegistro = async (e) => {
    e.preventDefault();
    setError('');

    // Validaciones
    const nombreRegex = /^[a-zA-ZÀ-ÿ\s]{3,40}$/;
    if (!nombreRegex.test(nombre.trim())) {
      setError('Por favor, ingresa un nombre válido (mínimo 3 letras).');
      return;
    }

    const telRegex = /^[0-9]{8,15}$/;
    if (!telRegex.test(telefono.trim())) {
      setError('Ingresa un número de teléfono válido (solo números).');
      return;
    }

    // --- 🎯 CONEXIÓN DIRECTA E INMUNE AL ENRUTADOR ---
    const RUTA_FISICA_REGISTRO = 'https://clavelinacarnes.com/clavelina-backend-php/src/Routes/clientes/registrar.php';

    try {
      // Le pegamos directo al archivo físico de cPanel para esquivar el HTML de React
      const res = await fetch(RUTA_FISICA_REGISTRO, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          nombre: nombre.trim(), 
          telefono: telefono.trim() 
        })
      });

      // 1. Obtenemos el texto plano primero para auditar la respuesta
      const text = await res.text();  
      
      try {
        // 2. Intentamos convertirlo a JSON
        const data = JSON.parse(text);
        console.log("🔍 Respuesta de PHP:", data);

        if (!res.ok || !data.success) {
          throw new Error(data.error || 'Error en el servidor');
        }

        const idFinal = data.cliente_id || data.id;

        if (idFinal) {
          localStorage.setItem('cliente_id', idFinal);
          localStorage.setItem('nombre_cliente', data.nombre || nombre.trim());
          localStorage.setItem('telefono_cliente', telefono.trim());
          window.dispatchEvent(new Event('storage'));
          setClienteId(idFinal);
        } else {
          setError("El servidor no devolvió un ID.");
        }

      } catch (parseError) {
        // 3. Si falla el parse, es porque PHP mandó HTML o un error de sintaxis
        console.error("❌ Error de formato (PHP mandó HTML):", text);
        setError("Error crítico del servidor. Revisa la pestaña Network.");
      }

    } catch (err) {
      console.error('❌ Error al registrar cliente:', err);
      setError(err.message);
    }
  };

  // 1. Si NO hay ID, mostramos el formulario de registro
  if (!clienteId || clienteId === "null" || clienteId === "undefined") {
    return (
      <div className="cliente-container">
        <div className="header-navigation">
          <button 
            onClick={() => window.location.href = 'http://localhost:3000/inicio'} 
            className="btn-link-inicio"
          >
            ← Volver al Inicio
          </button>
        </div>

        <div className="form-box">
          <div className="logo-section">
            <div className="logo-wrapper">
              <img src={logoImagotipo} alt="Carnes Clavelina" className="cliente-logo" />
              <div className="logo-shine-overlay"></div>
            </div>
            <h1 className="titulo-principal">CLAVELINA CARNES</h1>
            <h5 className="subtitulo">Chat de atención al cliente</h5>
          </div>

          <form onSubmit={handleRegistro} className="formulario">
            {error && <div className="error-badge">{error}</div>}

            <input
              type="text"
              placeholder="Nombre completo"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              required
              className="input-estilizado"
            />
            <input
              type="tel"
              placeholder="Teléfono (ej: 04121234567)"
              value={telefono}
              onChange={(e) => setTelefono(e.target.value)}
              required
              className="input-estilizado"
            />
            <button type="submit" className="btn-ingresar">
              Comenzar chat
            </button>
          </form>
          
          <div className="welcome-message">
            <p>Ingresa tus datos para comenzar a chatear con nosotros</p>
          </div>
        </div>
      </div>
    );
  }

  // 2. Si YA hay ID, mostramos la ventana de Chat (Dashbord)
  // IMPORTANTE: Usamos los nombres de props que espera tu ChatWindow
  return (
    <ChatWindow 
      usuario_id={clienteId} 
      nombre_cliente={nombre} 
      telefono={telefono}
    />
  );
}

export default ClienteView;